<template>

  <!-- Team Dialog -->
  <q-dialog
    full-width
    full-height
    ref="dialog"
    class="team-dialog">

    <q-card
      class="team-dialog__card shadow-0">

      <!-- Close -->
      <q-page-sticky
        :offset="[45, 30]"
        position="top-right"
        class="team-dialog__close">

        <q-btn
          flat
          round
          dense
          color="black"
          @click="hide"
          icon="fa lni-close"/>

      </q-page-sticky>

      <!-- Content -->
      <page-block
        class="team-dialog__content q-pt-md">

        <!-- Image -->
        <img
          v-if="image"
          :src="getFileUrl(image)"
          class="team-dialog__image xs-hide sm-hide"/>

        <!-- Accent -->
        <img
          class="team-dialog__accent"
          src="/images/icons/upper-chat-su-chef-element.svg"/>

        <h1>
          {{ users.length }} participant
        </h1>

        <!-- Users -->
        <div
          class="team-dialog__users">

          <!-- User -->
          <div
            :key="user.id"
            v-for="user in users"
            class="team-dialog__user">

            <q-avatar
              color="primary"
              text-color="white">
              {{ initials(user) }}
            </q-avatar>

            <div
              class="team-dialog__user-name">
              {{ user.name }}<br/>
              {{ user.surname }}
            </div>

          </div>

        </div>

        <!-- Empty Status -->
        <div
          v-if="!users.length"
          class="text-grey text-h3">
          {{ canJoin ? 'Do you want to be first?' : 'No one here' }}
        </div>

      </page-block>

      <div
        v-if="canJoin"
        class="team-dialog__footer">

        <!-- Join Button -->
        <q-btn
          rounded
          size="lg"
          unelevated
          color="primary"
          :loading="loading"
          :disable="loading"
          @click="$emit('join')"
          class="team-dialog__join-button">

          <div
            class="team-dialog__button-text">
            Join Chef's Team
          </div>

        </q-btn>

      </div>

    </q-card>

  </q-dialog>

</template>

<script>

  import PageBlock from '@src/components/page/page-block';

  export default {
    name: 'team-dialog',
    props: {
      image: {
        type: Object,
        default: () => ({}),
      },
      users: {
        type: Array,
        default: () => [],
      },
      loading: {
        type: Boolean,
        default: false,
      },
      canJoin: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      PageBlock,
    },
    data() {
      return {
        item: {},
      };
    },
    computed: {
    },
    methods: {
      show(item) {

        this.item = item;
        this.$refs.dialog.show();
      },
      hide() {

        this.$refs.dialog.hide();
      },
      initials(user) {

        const name = user.name
          ? user.name[0]
          : '';

        const surname = user.surname
          ? user.surname[0]
          : '';

        return name + surname || '??';
      },
    },
  };

</script>

<style lang="scss">

  $cls: team-dialog;

  .team-dialog {
    z-index: 1000;

    &__close {
      z-index: 10;
    }

    &__body {

      &__action {

        @media (max-width: $breakpoint-sm) {
          width: 100%;
          margin-top: 20px;
        }
      }
    }
  }

  .team-dialog__card {
    display: flex;
    text-align: center;
    flex-direction: column;

    h1 {
      font-size: 2rem;
      font-weight: bold;
      text-align: center !important;
    }

    .#{$cls}__accent {
      top: -70px;
      left: -40px;
      width: 180px;
      position: absolute;
    }

    .#{$cls}__image {
      left: 5%;
      top: 50px;
      max-width: 300px;
      position: absolute;
      width: auto !important;
    }

    .#{$cls}__users {
      text-align: left;
      display: inline-flex;
      flex-direction: column;
      align-items: flex-start;
    }

    .#{$cls}__user {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin-top: $spacer-sm;
      margin-bottom: $spacer-mm;

      .q-avatar {
        width: 75px;
        height: 75px;
        margin-right: $spacer-md;
      }
    }

    .#{$cls}__user-name {
      color: #555;
      font-size: 1.1rem;
    }

    .#{$cls}__content {
      overflow-y: auto;
      flex-basis: 100%;
      position: relative;
    }

    .#{$cls}__footer {
      flex-shrink: 0;
      padding: $spacer-mm;
      justify-content: center;
      background-color: white;
      box-shadow: 0 0 0.5rem #ddd;
    }
  }

</style>
